"use client";
import React, { useRef, useEffect, useState } from "react";

const HeroWithAudio = ({ title, description, audioSrc }) => {
  const audioRef = useRef(null);
  const sectionRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0; // Start the audio at 1 minute
    }

    const handleScroll = () => {
      const sectionTop = sectionRef.current.getBoundingClientRect().top;

      if (sectionTop <= 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      <section
        ref={sectionRef}
        className="relative flex flex-col items-center justify-center overflow-hidden rounded-xl shadow-xl h-auto sm:h-64"
      >
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src="/office.webp"
            alt="Office conversation about capital gains tax appraisals"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-gray-100/50 to-gray-300/60 dark:via-black/60 dark:to-black/80" />
        </div>

        {/* Audio Player */}
        <div
          className={`${
            isSticky
              ? "fixed bottom-0 left-0 right-0 z-50 bg-white dark:bg-gray-900 shadow-md p-4"
              : "relative w-full max-w-2xl p-4"
          } transition-all duration-300`}
        >
          <div className="w-full rounded-xl shadow-lg">
            <audio
              ref={audioRef}
              controls
              preload="auto"
              src={audioSrc}
              className="w-full focus:outline-none"
            >
              Your browser does not support the audio element.
            </audio>
          </div>
          
        </div>

        {/* Section Content */}
        <div className="relative z-10 w-full max-w-2xl p-4 text-center">
          
          <p className="text-md md:text-xl text-gray-700 dark:text-gray-300">{description}</p>
        </div>
      </section>
    </div>
  );
};

export default HeroWithAudio;